export const API_URL = {
  AUTH_LOGIN: "Login",
  BALANCE: "Balance",
  CURRENCYLIST:"CurrencyList",
  BUY:"Buy",
  DAYBOOKMF:"daybookMF",
  BETHISTORY:"BETHISTORY",
  CLOSEBET:"CLOSEBET",
};
